const jwtServiceConfig = {
  signIn: 'api/auth/sign-in',
  signUp: 'api/auth/sign-up',
  accessToken: 'api/auth/access-token',
  updateUser: 'api/auth/user/update',
};

export default jwtServiceConfig;
